import { Empty } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import { neutral } from "../tokens"
import type { WidgetProps } from "../types"
import { WidgetFrame } from "../WidgetFrame"

export const StubWidget = ({ widget, onRefresh, onExpand, editChrome }: WidgetProps) => {
  const { t } = useTranslation()
  const title = widget.config?.title ?? widget.title

  return (
    <WidgetFrame
      editChrome={editChrome}
      title={title}
      state="ready"
      capabilities={widget.capabilities}
      widgetId={widget.id}
      onRefresh={onRefresh}
      onExpand={onExpand}
    >
      <div data-testid="widget-stub" data-widget-type={widget.type}>
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={
            <span style={{ color: neutral.muted }}>
              {t("widget.stub.comingSoon", "Coming soon")}
            </span>
          }
        />
      </div>
    </WidgetFrame>
  )
}
